import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=6afccd80"
import script from "./BaseVideo.vue?vue&type=script&lang=js"
export * from "./BaseVideo.vue?vue&type=script&lang=js"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=6afccd80&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports